import { useSelector } from 'react-redux';
import { Success } from "./Success";
import { Error } from "./Error";

export const FinalScreen = ({ dimensions }) => {
    const state = useSelector(({ transaction }) => transaction);
    return !state.payment.error ? <Success /> : <Error />;
}